import React from "react";
import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./components/Header";
import NavDrawer from "./components/NavDrawer";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appbarSpacer: {
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    mainContentBox: {
      flexGrow: 1,
      minWidth: 0,
    },
    content: {
      padding: theme.spacing(2),
      overflow: "auto",
      height: `calc(100vh - 56px)`,
      [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
        height: `calc(100vh - 48px)`,
      },
      [theme.breakpoints.up("sm")]: {
        height: `calc(100vh - 64px)`,
      },
    },
  }),
);
export function Layout() {
  const classes = useStyles();
  return (
    <React.Fragment>
      <CssBaseline />
      <Header />
      <Box display="flex">
        <NavDrawer />
        <Box className={classes.mainContentBox}>
          <main>
            <div className={classes.appbarSpacer} />
            <div className={classes.content}>
              <Outlet />
            </div>
          </main>
        </Box>
      </Box>
    </React.Fragment>
  );
}
